import { FormGroup, Input } from "reactstrap";
import { attributeOptions } from "./InitialValues";
import SelectField from "../../../Utils/SelectField";
import { CreatableSelectField } from "../../../Utils/CreatableSelectField";
import InputField from "../../../Utils/InputField";

export const renderField = (field, handleChange, handleBlur, values, errors, touched, mandatoryChecked, mandatoryCheckedPersistence, mandatoryCheckedSelfcare, isEdit, setFieldValue, setFieldError, setFieldTouched,  setMandatoryIsChecked, setMandatoryIsCheckedPersistence, setMandatoryIsCheckedSelfcare, setIsChecked, isChecked, isAttribute, categoryOptions) => {
    const option = Array.isArray(attributeOptions) ? attributeOptions.find(opt => opt?.name === field?.name) : null;
    switch (field.type) {
        case "switch":
            return (
                <div className="d-flex align-items-center mt-2">
                    <FormGroup switch>
                        <Input  
                            type={"switch"}
                            className="rv-form-switch-input"
                            checked={field.label === "Mandatory" ? mandatoryChecked : field.label === "Selfcare" ? mandatoryCheckedSelfcare : field.name === "Counter" ? isCounter : field.label === "Rated Event Persistence" ? mandatoryCheckedPersistence : isChecked}
                            onClick={() => {
                                if (field.label === "Mandatory") {
                                    setMandatoryIsChecked(!mandatoryChecked);
                                } else if (field.label === "Selfcare") {
                                    setMandatoryIsCheckedSelfcare(!mandatoryCheckedSelfcare);
                                } else if (field.label === "Rated Event Persistence") {
                                    setMandatoryIsCheckedPersistence(!mandatoryCheckedPersistence);
                                }
                                else if (field.name === "Counter") {
                                    setIsCounter(!isCounter);
                                } else {
                                    setIsChecked(!isChecked)
                                }
                            }}
                            name={field.name}
                        />
                    </FormGroup>
                </div>
            )
        case "select":
            return (
                <SelectField
                    className={
                        (errors[field.name] && touched[field.name]) || false ? "error-input" : ""
                    }
                    value={values[field.name]}
                    placeholder={" "}
                    handleChange={(value) => {
                        if (!field?.insideTable) {
                            setFieldValue(`${field.name}`, value, false);
                            setFieldTouched(`${field.name}`, false);
                        }
                        else {
                            const newArray = [...values[field.arrayName]];
                            newArray[index] = {
                                ...newArray[index],
                                [field.name]: value,
                            };
                            setFieldValue(field.arrayName, newArray);
                            setFieldTouched(field.arrayName, false);
                        }
                    }}
                    options={option ? [...option.options] : []}
                    isRVStyle={true}
                    isDisabled={field.name === "valueType" && values?.type?.value === "inventory"} 
                />
            )
        case "creatable-select":
            return (
                <CreatableSelectField
                    className={
                        (errors[field.name] && touched[field.name]) || false ? "error-input" : ""
                    }
                    values={field.name === "category" ? values.category : values[field.name]}
                    placeholder={" "}
                    handleChange={(value) => {
                        setFieldValue(`${field.name}`, value, false);
                        setFieldTouched(`${field.name}`, false);
                    }}
                    onKeyDown={(event) => {
                        const key = event.key;
                        const regex = /^[a-zA-Z0-9]$/;
                        if (regex.test(key) || ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Enter'].includes(key)) {
                            event.stopPropagation();
                            return;
                        }
                        event.preventDefault();
                    }}
                    name={field.name}
                   options={
  field.name === "category"
    ? categoryOptions
    : option
    ? option.options
    : []
}
                    isMulti={field?.isMulti}
                    fieldLabel={field.label}
                    valuess={values}
                    fieldName={field.name}
                    setFieldValue={setFieldValue}
                    setFieldError={setFieldError}
                    isClearable={true}
                    isRVStyle={true}
                />
            )
        case "Selfcare-creatable-select":
            return (
                <CreatableSelectField
                    values={values[field.name]}
                    placeholder={field?.placeholder}
                    handleChange={(value) => {
                        setFieldValue(`${field.name}`, value, false);
                        setFieldTouched(`${field.name}`, false);
                    }}
                    onKeyDown={(event) => {
                        const key = event.key;
                        const regex = /^[a-zA-Z0-9]$/;
                        if (regex.test(key) || ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Enter'].includes(key)) {
                            return;
                        }
                        event.preventDefault();
                    }}
                    name={field?.name}
                    options={option ? option.options : []}
                    isMulti={field?.isMulti}
                    fieldLabel={field?.label}
                    fieldName={field?.name}
                    valuess={values}
                    setFieldError={setFieldError}
                    isAttribute={isAttribute}
                    setFieldValue={setFieldValue}
                    errors={errors[field.name]}
                    touched={touched[field.name]}
                    isRVStyle={true}
                />
            )
        default:
            return (
                <InputField
                    name={field.name}
                    type={field.type}
                    className={"form-control"}
                    id={field.name}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    value={values[field.name]}
                    invalid={
                        touched[field.name] && errors[field.name] ? true : false
                    }
                />
            )
    }
}